// Listen for cross origin events and send back height
(() => {
  if (window === parent) return;
  window.addEventListener('message', () => {
    parent.postMessage({ msg: 'Sis height updated', content: document.body.offsetHeight }, '*');
  });
})();
